<template>
	<div
		v-on:click="handleClick"
		class="flex justify-center items-center cursor-pointer"
		style="height: 100%"
	>
		<!-- <vx-tooltip text="Score SEO" placement="top"> -->
		<!-- Make to base 100 -->
		<vs-chip :color="getGradColor(101 - note * 10)" style="font-size: 12px">
			&nbsp;&nbsp;{{ note }}&nbsp;&nbsp;
		</vs-chip>
		<!-- </vx-tooltip> -->
	</div>
</template>
  
  <script>
import Vue from "vue";
import ProspectRadarChartPopup from "../ProspectRadarChartPopup.vue";
import DescColorChipRenderer from "./DescColorChipRenderer.vue";
import dbFieldConvertorMixin from "@/mixins/dbFieldConvertorMixin.js";
import utilsMixin from "@/mixins/utilsMixin.js";
export default {
	components: { DescColorChipRenderer },
	props: {
		onePs: Object, // Pass the data object that contains the `id` and `url`
	},
	data() {
		return {
			onePs: {},
			note: 0,
			noteRefreshKey: 0,
		};
	},
	mixins: [utilsMixin, dbFieldConvertorMixin],
	created() {
		this.onePs = this.params.data;
		this.getAverageNote();
	},
	methods: {
		getGradColor(val) {
			if (val == 0) return "primary"; // Default color if value is 0
			return this.gradientColor(val); // Get the gradient color
		},
		handleClick() {
			this.displayRadarChart(this.onePs.id, this.onePs.url);
		},
		getAverageNote() {
			let noteObj = this.onePs.noteSeo[0];
			let note = JSON.parse(noteObj.notes);

			// Get the values of the object
			const values = Object.values(note);

			// Calculate the average
			const average = values.reduce((acc, val) => acc + val, 0) / values.length;
			this.note = Math.round(Number(average));
			this.noteRefreshKey++;
		},
		/**
		 * Popup Issues Details
		 * @param {Number} pid - prospect Id
		 * @param {String} url - prospect url
		 */
		displayRadarChart(pid, url) {
			let ComponentClass = Vue.extend(ProspectRadarChartPopup);
			let radarChartPopup = new ComponentClass({
				propsData: {
					popupActive: true,
					prospectId: pid,
					prospect_url: url,
					notes: JSON.parse(this.onePs.noteSeo[0].notes),
				},
			});
			radarChartPopup.$mount();

			this.$refs.popupContainer.appendChild(radarChartPopup.$el);
		},
	},
};
</script>
  
  <style scoped>
/* Optional styling */
</style>